(function () {
  if (window.FGSMobileCheckoutDrawerLoaded) return;
  window.FGSMobileCheckoutDrawerLoaded = true;

  function rootUrl() {
    return window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  }

  function dispatchCartCount(cart) {
    document.dispatchEvent(new CustomEvent('cart:updated', {
      detail: { item_count: Number(cart.item_count || 0) }
    }));
  }

  function announce(message) {
    var notice = document.createElement('div');
    notice.className = 'fgs-cart-notice';
    notice.setAttribute('role', 'status');
    notice.setAttribute('aria-live', 'polite');
    notice.textContent = message;
    document.body.appendChild(notice);
    window.requestAnimationFrame(function () { notice.classList.add('is-visible'); });
    window.setTimeout(function () {
      notice.classList.remove('is-visible');
      window.setTimeout(function () { notice.remove(); }, 250);
    }, 2600);
  }

  function initDrawer(drawer) {
    if (!drawer || drawer.dataset.drawerReady === 'true') return;
    drawer.dataset.drawerReady = 'true';

    var id = drawer.dataset.drawerId;
    var title = drawer.querySelector('[data-drawer-title]');
    var type = drawer.querySelector('[data-drawer-type]');
    var detail = drawer.querySelector('[data-drawer-detail]');
    var quantity = drawer.querySelector('[data-drawer-quantity]');
    var savingRow = drawer.querySelector('[data-drawer-saving-row]');
    var saving = drawer.querySelector('[data-drawer-saving]');
    var compare = drawer.querySelector('[data-drawer-compare]');
    var shipping = drawer.querySelector('[data-drawer-shipping]');
    var total = drawer.querySelector('[data-drawer-total]');
    var error = drawer.querySelector('[data-drawer-error]');
    var minus = drawer.querySelector('[data-drawer-minus]');
    var plus = drawer.querySelector('[data-drawer-plus]');
    var add = drawer.querySelector('[data-drawer-add]');
    var buy = drawer.querySelector('[data-drawer-buy]');
    var edit = drawer.querySelector('[data-drawer-edit]');
    var close = drawer.querySelector('[data-drawer-close]');
    var content = drawer.querySelector('[data-drawer-content]');
    var panel = drawer.querySelector('.fgs-checkout-drawer__panel');
    var state = null;
    var busy = false;
    var dragStart = null;
    var dragPointerId = null;
    var dragDistance = 0;
    var dragMode = null;
    var suppressHandleClick = false;
    content.inert = true;
    content.setAttribute('aria-hidden', 'true');

    function money(cents) {
      if (state && typeof state.formatMoney === 'function') return state.formatMoney(cents);
      return window.FGSStorefrontMoney.format(cents, state && state.currency);
    }

    function setBusy(nextBusy) {
      busy = nextBusy;
      minus.disabled = busy || !state || state.quantity <= 1;
      plus.disabled = busy || !state;
      add.disabled = busy || !state;
      buy.disabled = busy || !state;
    }

    function render() {
      if (!state) return;
      var variant = state.variant;
      var count = state.quantity;
      var price = Number(variant.price || 0);
      var compareAt = Number(variant.compare_at_price || 0);
      var hasSaving = compareAt > price;
      var iconType = state.productType === 'sim' || state.productType === 'esim'
        ? state.productType
        : null;

      title.textContent = state.productTitle || '';
      type.textContent = state.productTypeLabel || '';
      type.hidden = !type.textContent;
      detail.textContent = (state.options || []).filter(Boolean).join(' • ');
      drawer.querySelector('[data-drawer-type-icon]').hidden = !iconType;
      quantity.textContent = count;
      total.textContent = money(price * count);
      savingRow.hidden = !hasSaving;
      saving.textContent = hasSaving ? money((compareAt - price) * count) : '';
      compare.textContent = hasSaving ? money(compareAt * count) : '';
      shipping.hidden = state.productType !== 'sim';
      drawer.querySelectorAll('[data-drawer-icon]').forEach(function (icon) {
        icon.hidden = icon.dataset.drawerIcon !== iconType;
      });
      error.textContent = '';
      setBusy(false);
    }

    function setMode(mode) {
      drawer.classList.toggle('is-open', mode === 'open');
      drawer.classList.toggle('is-minimized', mode === 'minimized');
      drawer.setAttribute('aria-hidden', mode === 'hidden' ? 'true' : 'false');
      content.inert = mode !== 'open';
      content.setAttribute('aria-hidden', mode === 'open' ? 'false' : 'true');
      close.setAttribute('aria-expanded', mode === 'open' ? 'true' : 'false');
      close.setAttribute('aria-label', mode === 'minimized'
        ? drawer.dataset.expandLabel
        : drawer.dataset.minimizeLabel);
      document.dispatchEvent(new CustomEvent('fgs:checkout-drawer:visibility', {
        detail: { drawerId: id, open: mode === 'open', minimized: mode === 'minimized' }
      }));
    }

    function open(nextState) {
      state = Object.assign({}, nextState, { quantity: Math.max(1, Number(nextState.quantity || 1)) });
      render();
      setMode('open');
      if (nextState.focusOnOpen) {
        window.requestAnimationFrame(function () { close.focus({ preventScroll: true }); });
      }
    }

    function minimize() {
      if (!drawer.classList.contains('is-open')) return;
      if (content.contains(document.activeElement)) close.focus({ preventScroll: true });
      setMode('minimized');
    }

    function expand() {
      if (drawer.classList.contains('is-minimized')) setMode('open');
    }

    function hide(restoreFocus) {
      setMode('hidden');
      if (restoreFocus && state && state.sourceElement) {
        var trigger = state.sourceElement.querySelector('[data-landing-buy]');
        if (trigger) trigger.focus({ preventScroll: true });
      }
    }

    minus.addEventListener('click', function () {
      if (!state || busy) return;
      state.quantity = Math.max(1, state.quantity - 1);
      render();
      document.dispatchEvent(new CustomEvent('fgs:checkout-drawer:quantity-change', {
        detail: { drawerId: id, sourceId: state.sourceId, quantity: state.quantity }
      }));
    });

    plus.addEventListener('click', function () {
      if (!state || busy) return;
      state.quantity += 1;
      render();
      document.dispatchEvent(new CustomEvent('fgs:checkout-drawer:quantity-change', {
        detail: { drawerId: id, sourceId: state.sourceId, quantity: state.quantity }
      }));
    });

    add.addEventListener('click', function () {
      if (!state || busy) return;
      setBusy(true);
      error.textContent = '';

      fetch(rootUrl() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: state.variant.id, quantity: state.quantity }] })
      }).then(function (response) {
        if (!response.ok) return response.json().then(function (body) {
          throw new Error(body.description || drawer.dataset.addErrorText);
        });
        return fetch(rootUrl() + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (cartResponse) {
            if (!cartResponse.ok) throw new Error('Cart refresh failed');
            return cartResponse.json();
          })
          .then(dispatchCartCount)
          .catch(function () {
            // A cart refresh failure must not turn a successful add into an add error.
          });
      }).then(function () {
        setBusy(false);
        if (drawer.dataset.hideAfterAdd === 'true') hide();
        announce(drawer.dataset.successText);
        if (drawer.dataset.scrollToTopAfterAdd === 'true' && window.innerWidth < 1024 && window.scrollY > 100) {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      }).catch(function (reason) {
        error.textContent = reason.message || drawer.dataset.addErrorText;
        setBusy(false);
      });
    });

    buy.addEventListener('click', function () {
      if (!state || busy) return;
      setBusy(true);
      var checkoutUrl = rootUrl() + 'cart/' + encodeURIComponent(state.variant.id) + ':' + state.quantity;
      window.location.assign(checkoutUrl);
    });

    edit.addEventListener('click', function () {
      if (!state) return;
      document.dispatchEvent(new CustomEvent('fgs:checkout-drawer:edit', { detail: state }));
    });

    close.addEventListener('click', function () {
      if (suppressHandleClick) return;
      if (drawer.classList.contains('is-minimized')) expand();
      else minimize();
    });
    close.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'mouse' || dragStart !== null ||
          (!drawer.classList.contains('is-open') && !drawer.classList.contains('is-minimized'))) return;
      dragStart = event.clientY;
      dragPointerId = event.pointerId;
      dragDistance = 0;
      dragMode = drawer.classList.contains('is-minimized') ? 'expand' : 'minimize';
      if (close.setPointerCapture) close.setPointerCapture(event.pointerId);
      panel.classList.add('is-dragging');
    });
    close.addEventListener('pointermove', function (event) {
      if (dragStart === null || event.pointerId !== dragPointerId) return;
      dragDistance = Math.max(0, dragMode === 'expand'
        ? dragStart - event.clientY
        : event.clientY - dragStart);
      panel.style.transform = dragMode === 'expand'
        ? 'translateY(calc(100% - var(--drawer-peek-height) - ' + dragDistance + 'px))'
        : 'translateY(' + dragDistance + 'px)';
    });
    function finishDrag(event) {
      if (dragStart === null || event.pointerId !== dragPointerId) return;
      var shouldChangeMode = event.type === 'pointerup' && dragDistance >= 70;
      var completedMode = dragMode;
      dragStart = null;
      dragPointerId = null;
      dragDistance = 0;
      dragMode = null;
      if (shouldChangeMode) {
        suppressHandleClick = true;
        if (completedMode === 'expand') expand();
        else minimize();
        window.setTimeout(function () { suppressHandleClick = false; }, 0);
      }
      panel.style.transform = '';
      panel.classList.remove('is-dragging');
    }
    close.addEventListener('pointerup', finishDrag);
    close.addEventListener('pointercancel', finishDrag);
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && drawer.classList.contains('is-open')) minimize();
    });

    document.addEventListener('fgs:checkout-drawer:open', function (event) {
      if (!event.detail || event.detail.drawerId !== id) return;
      open(event.detail);
    });

    document.addEventListener('fgs:checkout-drawer:close', function (event) {
      if (!event.detail || event.detail.drawerId !== id) return;
      hide(false);
    });

    document.addEventListener('fgs:checkout-drawer:minimize', function (event) {
      if (!event.detail || event.detail.drawerId !== id) return;
      minimize();
    });

    document.addEventListener('fgs:checkout-drawer:update', function (event) {
      if (!state || !event.detail || event.detail.drawerId !== id) return;
      if (event.detail.sourceId !== state.sourceId) return;
      var nextQuantity = event.detail.syncQuantity
        ? Math.max(1, Number(event.detail.quantity || 1))
        : state.quantity;
      state = Object.assign({}, state, event.detail, { quantity: nextQuantity });
      render();
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-mobile-checkout-drawer]').forEach(initDrawer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
